/** Feather a cutout by one texel. Keep interior drawing details sharp and
 * weight edge colours by alpha so transparent black/white cannot form a halo. */
export function smoothCutoutEdges(pixels: Uint8ClampedArray, width: number, height: number): Uint8ClampedArray {
  const output = new Uint8ClampedArray(pixels);
  for (let y = 0; y < height; y += 1) for (let x = 0; x < width; x += 1) {
    let alpha = 0, red = 0, green = 0, blue = 0;
    for (let dy = -1; dy <= 1; dy += 1) for (let dx = -1; dx <= 1; dx += 1) {
      const sx = x + dx, sy = y + dy;
      if (sx < 0 || sy < 0 || sx >= width || sy >= height) continue;
      const source = (sy * width + sx) * 4;
      const weight = (dx === 0 ? 2 : 1) * (dy === 0 ? 2 : 1);
      const coverage = pixels[source + 3] * weight;
      alpha += coverage;
      red += pixels[source] * coverage;
      green += pixels[source + 1] * coverage;
      blue += pixels[source + 2] * coverage;
    }
    // Fully covered neighbourhoods retain every colour of the original drawing.
    if (alpha === 0 || alpha === 255 * 16) continue;
    const target = (y * width + x) * 4;
    output[target] = red / alpha;
    output[target + 1] = green / alpha;
    output[target + 2] = blue / alpha;
    output[target + 3] = alpha / 16;
  }
  return output;
}
